import { RichTextSection } from './RichTextSection'
import { JuicerSocialWall } from "./JuicerSocialWall";
import { VimeoVideo } from "./VimeoVideo";

export const components = {
  rich_text_section: RichTextSection,
  juicer_social_wall: JuicerSocialWall,
  vimeo_video: VimeoVideo
}
